import { Component, h, Host, Prop } from '@stencil/core';

import { MessagesStore } from '../../../utils/Stores/messages-store';
import { SectionStore } from '../../../utils/Stores/section-store';

@Component({
  tag: 'events-module',
  styleUrl: 'events-module.scss',
  shadow: true,
})
export class ModuleEvents {
  @Prop() readonly reload: boolean;

  componentWillLoad() {
    if (MessagesStore?.get('messages').length === 0) {
      MessagesStore?.set('messages', []);
    }
  }

  render() {
    return (
      <Host>
        <event-switch-module reload={this.reload}></event-switch-module>
        <div class="error">
          <div
            class={{
              'error-unauthorized-bg': true,
              hide: SectionStore?.get('section')?.error_default,
            }}
          ></div>
          <div
            class={{
              'error-unauthorized-messages': true,
              hide: SectionStore?.get('section')?.error_default,
            }}
          >
            {MessagesStore?.get('messages')?.map((message) => {
              return (
                <bot-message-component
                  class="chat-messages__all"
                  message={message}
                ></bot-message-component>
              );
            })}
          </div>
        </div>
      </Host>
    );
  }
}
